import "./app.less";
import "./index.d";
import React, { JSX, Suspense, useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes';
import { GlobalDataProvider } from './stores/provider';
import { Loading } from "tdesign-react";

function RouteLoading(): JSX.Element {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShow(true);
    }, 200);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <Loading className="global-loading__fullscreen" loading={show} size="small" attach={'body'} showOverlay={false} />
  );
}

const router = createBrowserRouter(routes);
function App() {
  return (
    <GlobalDataProvider>
      <Suspense fallback={<RouteLoading />}>
        <RouterProvider router={router} />
      </Suspense>
    </GlobalDataProvider>
  );
}

export default App;
